import { useMutation, useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'
import {
  DataDownloadResponse,
  PlanningBookLedgerKeyFigure,
} from 'Features/DownloadDataModal/DownloadDataModal.types'
import { PlanPlanningBookLedgerDownloadParams } from 'Features/OperationalPlanner/DownloadDataModal/DownloadDataModal.types'

const fetchDashboardDownload = async ({
  planId,
  formSettings,
}: DataDownloadResponse) => {
  const { data } = await request({
    method: 'post',
    data: { formSettings },
    url: `plan/${planId}/operational-plan-download`,
  })
  return data
}

export const useDashboardDownload = (
  onSuccess: (data: any) => void,
  onError: () => void
) => {
  return useMutation(fetchDashboardDownload, {
    onSuccess: (data) => {
      onSuccess(data)
    },
    onError: () => {
      onError()
    },
  })
}

// US149971: 200 on a plan with a PlanningBookLedger catalogue (the option is
// offered); 404 LEDGER_NOT_AVAILABLE otherwise (the option is absent).
export const usePlanPlanningBookLedgerKeyFigures = (
  planId: string,
  enabled: boolean
) => {
  return useQuery(
    ['plan-planning-book-ledger-key-figures', planId],
    async () => {
      const { data } = await request({
        url: `plan/${planId}/planning-book-ledger`,
      })
      return data
    },
    {
      select: (data): PlanningBookLedgerKeyFigure[] =>
        data?.data?.keyFigures ?? [],
      enabled,
      refetchOnWindowFocus: false,
    }
  )
}

// The selected work centres go as work-centre keys (the ledger's partition
// key); csv comes back as the attachment, xlsx as {data, column_order}. The
// dialog's xlsx value is 'xlxs'; the route takes 'xlsx'.
const fetchPlanPlanningBookLedgerDownload = async ({
  planId,
  workcentres,
  settings,
}: PlanPlanningBookLedgerDownloadParams) => {
  const { data } = await request({
    method: 'post',
    data: {
      settings: {
        workcentres,
        fileVersion: settings.fileVersion,
        keyFigures: settings.keyFigures,
        fileFormat: settings.fileFormat === 'csv' ? 'csv' : 'xlsx',
      },
    },
    url: `plan/${planId}/planning-book-ledger`,
  })
  return data
}

export const usePlanPlanningBookLedgerDownload = (
  onSuccess: (data: any) => void,
  onError: (error: unknown) => void
) => {
  return useMutation(fetchPlanPlanningBookLedgerDownload, {
    onSuccess: (data) => {
      onSuccess(data)
    },
    onError: (error) => {
      onError(error)
    },
  })
}
